export const ERROR = "ERROR";
export const HIDE_ERROR = "HIDE_ERROR";
export const COMMON_START_LOADER = "COMMON_START_LOADER";
export const COMMON_STOP_LOADER = "COMMON_STOP_LOADER";
export const ADD_MSG = "ADD_MSG";
export const CLEAR_MSG = "CLEAR_MSG";
export const UPDATE_TIME = "UPDATE_TIME";
